import { makeStyles } from '@material-ui/core';

export default makeStyles({
  title: {
    fontWeight: 700,
  },
});
